import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';

export const environment = {
  production: false,
  name: 'local',
  skipDynamicEnvironment: true,
  isStation: true,
  apis: {
    appInsights: {
      instrumentationKey: '8da56511-8577-4b36-93ff-25c618858613',
    },
    azure: {
      correlationTokenName: 'abc-correlation-token',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: 'df6b52c9ec7b4df188cf7200788ccb5c',
    },
    diagnosisCode: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/reference/diagnosiscodes',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '6d7069de596d4d9f9f2a5d2bf978ae43',
    },
    entitlements: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Entitlements',
    },
    emrintegration: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/emr-integration',
    },
    e2e: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/e2e',
    },
    formulary: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Formulary',
    },
    identity: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Identity',
    },
    pricing: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Pricing',
    },
    inventory: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Inventory',
    },
    mockInventory: {
      endpoint: 'app/shared/fakes/inventory.json',
    },
    lookup: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Lookup',
    },
    party: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Party',
    },
    purchaseorder: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/PurchaseOrder',
    },
    patient: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Patient',
    },
    physician: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Party/Physicians',
    },
    printing: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/Printing',
    },
    stationConfiguration: {
      endpoint: 'app/shared/fakes/station-configuration.json',
    },
    stationmanagement: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/station',
    },
    configuration: {
      endpointUrl: 'https://services.dev.hdp.amerisourcebergen.com/configuration',
    },
  },
  useStateManagement: false,
  useApiPrinting: false,
  msalConfig: {
    interactionType: InteractionType.Popup,
    auth: {
      clientId: '9d3db210-f3a4-4879-856d-12af0b25cb4d',
      navigateToLoginRequestUrl: false,
      redirectUri: '/auth',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggingOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  },
  apiConfig: {
    scopes: ['9d3db210-f3a4-4879-856d-12af0b25cb4d'],
    uri: 'https://services.dev.hdp.amerisourcebergen.com',
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_local_signin',
      resetPassword: 'B2C_1A_local_signin',
      editProfile: 'B2C_1A_local_signin',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://PSGCustomerDev.b2clogin.com/PSGCustomerDev.onmicrosoft.com/B2C_1A_local_signin',
      },
      resetPassword: {
        authority: 'https://PSGCustomerDev.b2clogin.com/PSGCustomerDev.onmicrosoft.com/B2C_1A_local_signin',
      },
      editProfile: {
        authority: 'https://PSGCustomerDev.b2clogin.com/PSGCustomerDev.onmicrosoft.com/B2C_1A_local_signin',
      },
    },
    authorityDomain: 'PSGCustomerDev.b2clogin.com',
  },
  cmsUrl: 'https://cms.nucleusinventory.com/cms/production/stationmvp/',
};
